"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _HBTableRow = _interopRequireDefault(require("./HBTableRow"));
var _HBTable = require("./HBTable.styles");
var _HBTableHorizontalShadowSyncScrollContainer = _interopRequireDefault(require("./HBTableHorizontalShadowSyncScrollContainer"));
var _useFocusGroup = _interopRequireDefault(require("../common/useFocusGroup"));
function HBTableBody(_ref) {
  var _table$getRowModel$ro;
  var table = _ref.table,
    setTableBodyEl = _ref.setTableBodyEl;
  (0, _useFocusGroup["default"])("".concat(_HBTable.Table, " ").concat(_HBTableRow["default"].TR), {
    ltr: false
  });
  if (table.options.meta.isInitialLoading) {
    return null;
  }
  return /*#__PURE__*/_react["default"].createElement(_HBTableHorizontalShadowSyncScrollContainer["default"], {
    table: table
  }, /*#__PURE__*/_react["default"].createElement(_HBTable.Table, {
    ref: setTableBodyEl
  }, /*#__PURE__*/_react["default"].createElement("tbody", null, (_table$getRowModel$ro = table.getRowModel().rows) === null || _table$getRowModel$ro === void 0 ? void 0 : _table$getRowModel$ro.map(function (row) {
    return /*#__PURE__*/_react["default"].createElement(_HBTableRow["default"], {
      key: row.id,
      row: row,
      table: table,
      isLoading: table.options.meta.isLoading
    });
  }))));
}
var _default = exports["default"] = HBTableBody;
//# sourceMappingURL=HBTableBody.js.map